import { Navigate, useLocation, useSearchParams } from 'react-router-dom'
import type { DiscoverType } from '@/hooks/useDiscoverUrlFilters'

function mapLegacyFeedType(contentType: string | null): DiscoverType {
  if (contentType === 'tattoos') return 'tattoos'
  if (contentType === 'flashes') return 'flashes'
  return 'flashes'
}

interface DiscoverLegacyRedirectProps {
  legacyType: 'feed' | 'artists'
}

export function DiscoverLegacyRedirect({ legacyType }: DiscoverLegacyRedirectProps) {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const nextParams = new URLSearchParams(searchParams)

  nextParams.delete('content-type')

  if (legacyType === 'artists') {
    nextParams.set('type', 'artists')
  } else {
    const contentType = searchParams.get('content-type')
    const mappedType = mapLegacyFeedType(contentType)
    if (mappedType === 'flashes') {
      if (!nextParams.get('type')) {
        nextParams.delete('type')
      }
    } else {
      nextParams.set('type', mappedType)
    }
  }

  const queryString = nextParams.toString()
  const target = queryString ? `/discover?${queryString}` : '/discover'

  return <Navigate to={`${target}${location.hash}`} replace />
}
